import * as React from 'react';
import { CartService, CartServiceProps } from '../types';
import Flights from './Flights';
import Baggage from './Baggage';
import Seats from './Seats';
import Meals from './Meals';
import Passengers from './Passengers';
import Extra from './Extra';
import Insurance from './Extra/Insurance';
import Misc from './Misc';

interface OwnProps {
	type: CartService;
}

type Props = OwnProps & CartServiceProps;

const CartFactory: React.FC<Props> = ({ type, ...props }) => {
	switch (type) {
		case CartService.Flights:
			return <Flights {...props} />;

		case CartService.Baggage:
			return <Baggage {...props} />;

		case CartService.Seats:
			return <Seats {...props} />;

		case CartService.Meal:
			return <Meals {...props} />;

		case CartService.Passengers:
			return <Passengers {...props} />;

		case CartService.Extra:
			return <Extra {...props} />;

		case CartService.Insurances:
			return <Insurance {...props} />;

		case CartService.Misc:
			return <Misc {...props} />;

		default:
			return null;
	}
};

export default CartFactory;
